import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material";

import Contact from "./pages/Contact";
import ErrorBoundary from "./components/ErrorBoundary";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import LectureCreate from "./pages/LectureCreate";
import LectureDetails from "./pages/LectureDetails";
import { LectureListContextProvider } from "./contexts/LectureListContext";
import Login from "./pages/Login";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Profile from "./pages/Profile";
import Register from "./pages/Register";
import ThankYou from "./pages/ThankYou";
import { getAreas } from "./stores/areas/areasSlice";
import { getInstructors } from "./stores/instructors/instructorsSlice";
import { getTopics } from "./stores/topics/topicsSlice";
import { setBearerToken } from "./utils/http";
import { useDispatch } from "./stores";
import { useEffect } from "react";

const theme = createTheme({
    palette: {
        primary: {
            main: "#F1EEDB",
        },
        secondary: {
            main: "#4F8CAD",
        },
    },
});

const App = () => {
    const dispatch = useDispatch();

    const token = localStorage.getItem("token");
    if (token) {
        setBearerToken(token);
    }

    useEffect(() => {
        dispatch(getTopics());
        dispatch(getInstructors());
        dispatch(getAreas());
    }, [dispatch]);

    return (
        <ErrorBoundary>
            <ThemeProvider theme={theme}>
                <LectureListContextProvider>
                    <Router>
                        {/* <Navbar /> */}

                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/home" element={<Home />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/create" element={<LectureCreate />} />
                            <Route
                                path="/lecture/:lectureId"
                                element={<LectureDetails />}
                            />
                            <Route
                                path="/privacy-policy"
                                element={<PrivacyPolicy />}
                            />
                            <Route path="/contact-us" element={<Contact />} />
                            <Route path="/thank-you" element={<ThankYou />} />
                            <Route path="/profile" element={<Profile />} />
                        </Routes>
                    </Router>
                </LectureListContextProvider>
            </ThemeProvider>
        </ErrorBoundary>
    );
};

export default App;
